import FileUploadInputComponent from '../../../components/file/file-upload-input.component';
import IMEISerialSalesCheckingModel from '../../../models/IMEI-SERIAL-sales-checking/IMEI-SERIAL-sales-checking.model';
import ViewBase from '../../view-base.view';

/**
 * IMEI/Serial Sales Checking View
 * 
 * A page to upload IMEI/Serial Sales Checking excel file
 * 
 * @author cmcnkhiep
 */

export default function IMEISerialSalesCheckingView() {

    ViewBase.call(this);

    const FORM_ID = 'uploadIMEISerialListForm'
    const DATA_TYPE = {
        IMEI: { name: 'IMEI', value: 'IMEI' },
        SERIAL: { name: 'Serial Number', value: 'Serial' }
    };

    let dataType = DATA_TYPE.IMEI.value
    let fileData = null;
    let resultTotal = 0;
    let resultFileId = ''

    const clearFileInput = () => {
        let fileInput = document.getElementById('imeiSerialFileInput');
        fileInput.value = null;
        fileData = null;
    }

    const clearFilter = () => {
        dataType = DATA_TYPE.IMEI.value;
        clearFileInput()
    };

    const downloadIMEISerialSalesTemplate = () => {
        this.showLoading();
        IMEISerialSalesCheckingModel.getExcelTemplate(dataType).catch((error) => {
            this.handleError(error);
        }).finally(() => {
            this.hideLoading();
        })
    }

    const uploadIMEISerialList = (e) => {
        // Form validation
        if (!this.validateForm(e)) {
            clearFileInput();
            return false;
        }

        this.showLoading();
        IMEISerialSalesCheckingModel.uploadIMEISerialList(dataType, fileData)
            .then((result) => {
                resultTotal = result.totalCount;
                resultFileId = result.guidId;
                this.showMessage(this.getText('EM00000313', 'Upload Completed'), this.getText('LT00000475', 'Success'))
            })
            .catch((error) => {
                this.handleError(error);
                resultTotal = 0;
            })
            .finally(() => {
                clearFileInput();
                this.hideLoading();
            })

    }

    const downloadIMEISerialUploadResult = () => {
        IMEISerialSalesCheckingModel.downloadIMEISerialUploadResult(resultFileId)
    }

    return {
        view: () => {
            return [
                m('.card.mb-3',
                    m('.card-body',
                        m('.row.mb-4',
                            m('label.form-label[for="dataTypeInput"]',
                                'Data Type'
                            ),
                            m('#dataTypeInput', { value: dataType, onchange: (e) => { dataType = e.target.value; } },
                                m('.form-check.form-check-inline',
                                    m('input#imeiOption.form-check-input[type="radio"]',
                                        {
                                            value: DATA_TYPE.IMEI.value,
                                            checked: dataType == DATA_TYPE.IMEI.value,
                                        }
                                    ),
                                    m('label.form-check-label[for="imeiOption"]',
                                        DATA_TYPE.IMEI.name
                                    )
                                ),
                                m('.form-check.form-check-inline',
                                    m('input#serialOption.form-check-input[type="radio"]',
                                        {
                                            value: DATA_TYPE.SERIAL.value,
                                            checked: dataType == DATA_TYPE.SERIAL.value,
                                        }
                                    ),
                                    m('label.form-check-label[for="serialOption"]',
                                        DATA_TYPE.SERIAL.name
                                    )
                                )
                            )
                        ),
                        m('form.row.g-4.align-items-end.needs-validation[novalidate]', { id: FORM_ID, onsubmit: uploadIMEISerialList },
                            m('.col-xl-6',
                                m('label.form-label.mandatory[for="imeiSerialFileInput"]',
                                    this.getText('LT8038', 'IMEI/Serial Number List')
                                ),
                                m(FileUploadInputComponent,
                                    {
                                        id: 'imeiSerialFileInput',
                                        required: true,
                                        accept: '.xlsx,.xls',
                                        onTemplateDownloadClick: downloadIMEISerialSalesTemplate,
                                        onInput: (data) => { fileData = data; },
                                    }
                                ),

                            ),
                            m('.col-12.d-flex.justify-content-end.gap-2',
                                m('button.btn.btn-primary',
                                    {
                                        disabled: !fileData,
                                        type: 'submit',
                                    },
                                    this.getText('LT00000290', 'Upload')
                                ),
                                m('button.btn.btn-white',
                                    {
                                        type: 'button',
                                        onclick: () => {
                                            clearFilter();
                                        }
                                    },
                                    this.getText('LT00000031', 'Clear')
                                )
                            )
                        )
                    )
                ),

                resultTotal > 0 &&
                m('.card',
                    m('.card-body',
                        m('.d-flex.align-items-center.justify-content-between.p-2',
                            m('span',
                                `${this.getText('LT8039', 'Total Record(s) from Uploaded Excel')}: ${resultTotal}`
                            ),
                            m('.d-flex.gap-2',
                                m('button.btn.btn-primary',
                                    {
                                        disabled: !resultFileId,
                                        onclick: downloadIMEISerialUploadResult
                                    },
                                    m('i.bi.bi-file-earmark-arrow-down-fill'),
                                    this.getText('LT00000492', 'Download')
                                )
                            )
                        )
                    )
                ),

                this.getBaseViews()
            ];
        }
    };
}
